import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'commas' })
export class CommasPipe implements PipeTransform {
  transform(value: string[]): string {
    if (!Array.isArray(value) || value.filter(i => typeof i !== 'string').length > 0) {
      return '';
    }
    return value.join(', ');
  }
}
